
export type VerifyAmountBody = {
  expectedAmount: number;
  orderId: string;
};
